import { Table, TableHead, TableBody } from "@mui/material";
import ServicesTableHead from "./ServicesTableHead"; // Your existing header component for Services
import ServiceRow from "../pages/ServiceRow";          // Adjust the import if needed

function ServicesTable({ data, columns, order, orderBy, onSortRequest }) {

  return (
    <Table>
      <TableHead>
        <ServicesTableHead 
          columns={columns} 
          order={order} 
          orderBy={orderBy} 
          onSortRequest={onSortRequest}
        />
      </TableHead>
      <TableBody>
        {data.map((service) => (
          <ServiceRow key={service.id} service={service} columns={columns} services={data}/>
        ))}
      </TableBody>
    </Table>
  );
}

export default ServicesTable;